import React, { useContext } from 'react';
import PageLayout from '../pagelayout';
import { useIntl } from 'react-intl';
import translations from './myorganization.psa.i18n';
import { ToolbarLink } from '../pagelayout/toolbarLink';
import Icon, { IconType } from '../components/icon';
import Colleagues from './colleagues.psa';
import Departments from './departments.psa';
import * as css from './myorganization.psa.module.scss';
import { Route, Routes } from 'react-router-dom';
import { BrukerrollerDto } from '../api/generated/praksissted-generated-api';
import { PsaUserContext } from '../user/PsaUserStore';
import PraksisstedbrukerprofilPage from '../userprofile/praksisstedbrukerprofilpage.psa';
import PracticePlaceProfilePagePsa from '../practiceplaces/practiceplaceprofile/practiceplaceprofilepage.psa';
import { InvitePsUserPagePSA } from '../invite/invitePsUserPage';
import AgreementTable from './agreementtable.psa';
import { Tab, Tabs } from '../components/tabs/tabs';
import { PracticePlaceAgreementProviderPS } from '../practiceplaces/practiceplaceagreement';
import { PageNotFoundWithoutLayout } from '../pages/pagenotfound';

const MyOrganizationPsaPage = () => {
  const { psaUser: bruker } = useContext(PsaUserContext);
  const { formatMessage } = useIntl();

  const labels = {
    title: formatMessage({ id: translations.title.id }),
    subtitle: formatMessage({ id: translations.subtitle.id }),
    newuser: formatMessage({ id: translations.newuser.id }),
    colleagues: formatMessage({ id: translations.colleagues.id }),
    departments: formatMessage({ id: translations.departments.id }),
    workPlaceProfile: formatMessage({ id: translations.workPlaceProfile.id }),
    agreements: formatMessage({ id: translations.agreements.id }),
  };

  const inviteButton: React.ReactNode =
    bruker &&
    bruker.hoeyesteRettighet === BrukerrollerDto.Administrator &&
    ToolbarLink({
      title: labels.newuser,
      exact: true,
      path: 'invite',
      icon: <Icon type={IconType.AddCircleRounded} />,
    });

  return (
    <Routes>
      <Route path="/invite" element={<InvitePsUserPagePSA />} />
      <Route
        path="/praksisstedbrukerprofil/:id"
        element={<PraksisstedbrukerprofilPage />}
      />
      <Route
        path="/practiceplaces/profile/:id"
        element={<PracticePlaceProfilePagePsa />}
      />
      <Route
        path="/agreements/:avtaleId"
        element={<PracticePlaceAgreementProviderPS />}
      />
      <Route
        path="/*"
        element={
          <PageLayout
            isIndented
            title={labels.title}
            subtitle={labels.subtitle}
            actionItems={inviteButton}
            className={css.page}
          >
            <Tabs>
              <Tab to="" end>
                {labels.colleagues}
              </Tab>
              <Tab to="departments">{labels.departments}</Tab>
              <Tab to="agreements">{labels.agreements}</Tab>
            </Tabs>
            <Routes>
              <Route path="" element={<Colleagues />} />
              <Route path="departments" element={<Departments />} />
              <Route path="agreements" element={<AgreementTable />} />
              <Route path="*" element={<PageNotFoundWithoutLayout />} />
            </Routes>
          </PageLayout>
        }
      />
    </Routes>
  );
};

export default MyOrganizationPsaPage;
